import script from "./ProgramCommitteeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramCommitteeView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramCommitteeView.vue?vue&type=style&index=0&id=1a3a23ad&scoped=true&lang=css"
import "./ProgramCommitteeView.vue?vue&type=style&index=1&id=1a3a23ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3a23ad"]])

export default __exports__